import { UnleashClient } from 'unleash-proxy-client';

const unleashConfig = {
  // eslint-disable-next-line no-undef
  url: `${globalThis.location.origin}/unleash`,
  clientKey: process.env.VUE_APP_UNLEASH_CLIENT_KEY,
  refreshInterval: 15,
  appName: 'customer-portal',
};

const unleash = new UnleashClient({ ...unleashConfig });

unleash.start();

export default unleash;
